import { call, put, select } from "redux-saga/effects";
import { disagregateProduct as getDisagregateProductAda } from "@bitComponents/adabyron/catalog";
import { WEB_SERVICES } from "./webServices";
import { prepareDisagregatedDataIn } from "../utils/normalizers";

const contextStore = (state) => state.context.data;

export function* getDisagregateProduct(params) {
  const {
    allPOsToBuy,
    poN,
    netflixPlan,
    poR,
    storageId,
    colorId,
    reduxUpdate,
    normalizeHttpErrors,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    let data = {};
    data = prepareDisagregatedDataIn({
      allPOsToBuy,
      poN,
      netflixPlan,
      poR,
      storageId,
      colorId,
    });
    data.customNormalizer = (responseDisagregate) => responseDisagregate;
    const context = yield select(contextStore);
    const response = yield call(getDisagregateProductAda, data, context);
    yield put(successUpdate(response));
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.DISAGREGATE_PRODUCT,
      error
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }
  }
}
